import { Box, Flex, Icon, Image, Link, Text } from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';
import {
  getPathInfo,
  isCategoryInSameView,
  useRealPathname,
} from '@ui/hooks/router';
import { useTranslations } from '@ui/i18n';
import { Discord, Medium, Twitter } from '@veno-app/icons';

const Footer = ({ hidden }: { hidden?: boolean }) => {
  const t = useTranslations();
  const realPathname = useRealPathname();
  const pathInfo = getPathInfo(realPathname);
  const isInLandingView = isCategoryInSameView(pathInfo.category, 'landing');
  const shouldHidden = hidden ?? isInLandingView;

  return (
    <InDesktop>
      {!shouldHidden && (
        <Flex mt="auto" flexDir="column">
          {/* make sure 50px or more (auto) between content and footer */}
          <Box h="50px" />
          <Flex
            flex="1"
            w="full"
            pt="16px"
            pb="24px"
            borderTop="1px solid rgba(180, 193, 213, 0.75)"
            flexDir="column"
            align="center"
          >
            <Text color="#000000" textStyle="bodySmall">
              {t('Join the community')}
            </Text>
            <Flex pt="18px" w="137px" justify="space-between">
              <Link
                rel="noopener noreferrer"
                target="_blank"
                href={EXTERNAL_LINK.twitter}
              >
                <Icon color="text.active" w="16px" h="16px" as={Twitter} />
              </Link>
              <Link
                rel="noopener noreferrer"
                target="_blank"
                href={EXTERNAL_LINK.medium}
              >
                <Icon color="text.active" w="16px" h="16px" as={Medium} />
              </Link>
              <Link
                rel="noopener noreferrer"
                target="_blank"
                href={EXTERNAL_LINK.discord}
              >
                <Icon color="text.active" w="16px" h="16px" as={Discord} />
              </Link>
            </Flex>
            <Link
              rel="noopener noreferrer"
              target="_blank"
              href={EXTERNAL_LINK.whitepaper}
              mt="21px"
              mb="23px"
              color="pink.500"
              textStyle="textLink"
            >
              {t('Whitepaper')}
            </Link>
            <Flex
              w="200px"
              pt="20px"
              justify="center"
              borderTop="1px solid rgba(180, 193, 213, 0.75)"
            >
              <Box>
                <Image
                  alt="VENO"
                  src="/images/cronoslabs.png"
                  w="92px"
                  h="26px"
                />
              </Box>
            </Flex>
          </Flex>
        </Flex>
      )}
    </InDesktop>
  );
};

export default Footer;
